module.exports = __webpack_public_path__ + "img/pixing_xc2.7ce8b4a5.jpg";